module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#album",
      toString: function () {
        return this.url;
      }
    }